/* MkaeSense: Canada + US helpers (delivery estimate, compatibility notes, free-shipping threshold in local currency) */
(function(){
  var S=window.Shopify||{}; var cc=(S.country||'CA'); var cur=(S.currency&&S.currency.active)||'CAD'; var rate=(S.currency&&parseFloat(S.currency.rate))||1;
  var isUS=(cc==='US');

  /* Free-shipping threshold is $75 CAD; show US visitors the USD equivalent (rounded up so the claim is always true) */
  function localizeThreshold(){
    if(cur!=='USD') return;
    var usd=Math.ceil(75*rate);
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null), n, list=[];
    while((n=w.nextNode())){ if(/\$75(?!\d)/.test(n.nodeValue) && !/script|style/i.test(n.parentNode.nodeName)) list.push(n); }
    list.forEach(function(t){ t.nodeValue=t.nodeValue.replace(/\$75(?!\d)(\s?CAD)?/g,'$'+usd+' USD'); });
  }

  function addBD(d,n){ var r=new Date(d.getTime()); while(n>0){ r.setDate(r.getDate()+1); var g=r.getDay(); if(g!==0&&g!==6) n--; } return r; }
  function fmt(d){ try{ return d.toLocaleDateString('en-CA',{month:'short',day:'numeric'}); }catch(e){ return (d.getMonth()+1)+'/'+d.getDate(); } }

  function eta(){
    if(document.querySelector('.mk-eta')) return;
    var anchor=document.querySelector('.mk-trust')||document.querySelector('.buy-buttons-block'); if(!anchor||!anchor.parentNode) return;
    /* from shipping policy: 1-3 business days processing + 7-15 (Canada) or 5-12 (US) business days in transit */
    var lo=isUS?6:8, hi=isUS?15:18, now=new Date();
    var el=document.createElement('div'); el.className='mk-eta';
    el.innerHTML='<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg><div><strong>Estimated delivery to '+(isUS?'the US':'Canada')+'</strong><span class="mk-eta-dates">'+fmt(addBD(now,lo))+' – '+fmt(addBD(now,hi))+'</span>Tracked shipping. Some items from North American stock arrive sooner; your exact window shows at checkout.</div>';
    anchor.parentNode.insertBefore(el,anchor.nextSibling);
  }

  function notes(){
    if(document.querySelector('.mk-note')||!document.querySelector('.mk-eta')) return;
    var h=document.querySelector('h1'); if(!h) return; var t=h.textContent||''; var html='';
    if(/4G|cellular|LTE/i.test(t)) html='<strong>4G camera: a data plan is needed</strong>These cameras connect through a cellular data plan from your own carrier (SIM not included unless the listing says so). Not sure your carrier is supported? <a href="mailto:mkaesense@outlook.com?subject=4G%20carrier%20check">Email us your carrier</a> and we\'ll check before you order.';
    else if(/tracker|gps|immobili|faraday|steering|obd|anti-theft|key fob|push-button|jump start/i.test(t)) html='<strong>Check fit before you buy</strong>Not sure it works with your vehicle? <a href="mailto:mkaesense@outlook.com?subject=Vehicle%20fit%20check">Email us the make, model and year</a> and we\'ll tell you before you order.';
    if(!html) return;
    var n=document.createElement('div'); n.className='mk-note'; n.innerHTML=html; var e=document.querySelector('.mk-eta'); e.parentNode.insertBefore(n,e.nextSibling);
  }

  var timer=null;
  function run(){ localizeThreshold(); eta(); notes(); }
  function start(){ run(); new MutationObserver(function(){ clearTimeout(timer); timer=setTimeout(run,150); }).observe(document.body,{childList:true,subtree:true}); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();

/* loads the future layer (sunlight board, quiz, product cards); 10-minute cache key so edits reach visitors quickly */
(function(){
  try{
    var me=document.currentScript, src=me&&me.src; if(!src) return;
    var base=src.replace(/mk-extra\.js.*$/,'');
    var sc=document.createElement('script'); sc.src=base+'mk-future.js?v='+Math.floor(Date.now()/600000); sc.defer=true; document.head.appendChild(sc);
  }catch(e){}
})();
